
import imgIcon from './images/encyclopediaIndexBg.jpg';
import imgLogo from './images/encyclopediaIndexLogo.jpg';
import XHeader from 'vux/src/components/x-header/index.vue'

export default {
data(){
return{
imgIcon,
imgLogo
}
},
components: {
XHeader
},
methods:{
lookpage(e){
this.$router.push({path:'/TestTubeEncyclopediaList',query:{headTitle:e.target.childNodes[1].nodeValue}});
}
}
}



// WEBPACK FOOTER //
// ./src/project/testTubeEncyclopedia/TestTubeEncyclopediaIndex.vue